import type { AppLocale } from './detect';
import { getLocale } from './index';

const INTL_LOCALE: Record<AppLocale, string> = {
  it: 'it-IT',
  en: 'en-US',
};

export function intlLocale(locale?: AppLocale): string {
  return INTL_LOCALE[locale ?? getLocale()];
}

export function formatDateForLocale(
  iso: string,
  opts?: Intl.DateTimeFormatOptions,
  locale?: AppLocale,
): string {
  const [y, m, d] = iso.split('-').map(Number);
  if (!y) return iso;
  try {
    return new Intl.DateTimeFormat(intlLocale(locale), {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      timeZone: 'UTC',
      ...opts,
    }).format(new Date(Date.UTC(y, m - 1, d)));
  } catch {
    return iso;
  }
}

/** Year only, for the compact tombstone face where a full date overflows. */
export function formatYearForLocale(iso: string): string {
  const year = Number.parseInt(iso.slice(0, 4), 10);
  if (!Number.isFinite(year) || year < 1000) return iso;
  return String(year);
}

const YEAR_TOKEN_RE = /\b(?:1[89]\d{2}|20\d{2}|21\d{2})\b/g;

/** Pull birth/death years out of a free-text lifespan such as "settembre 2011 – 3 marzo 2024". */
export function yearsFromLifespan(value: string): string[] {
  const matches = value.match(YEAR_TOKEN_RE);
  if (!matches?.length) return [];
  return [...new Set(matches)];
}

export function formatDateTime(iso: string, locale?: AppLocale): string {
  try {
    return new Date(iso).toLocaleDateString(intlLocale(locale), {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return '';
  }
}
